export const PROFILE_MENU = {
  name: "Meu perfil",
  subLinks: [
    { name: "Meus dados", url: "/app/profile" },
    // { name: "Mensagens prontas" },
    // { name: "Treinamentos" },
    { name: "Sair", url: "/app/logout" },
  ],
};

export const MENU_LINKS = [
  {
    name: "Contatos",
    subLinks: [
      {
        name: "Conversas",
        url: "/app",
      },
      {
        name: "Criar novo contato",
        url: "/app/customer/new",
      },
    ],
  },
  {
    name: "Relatórios",
    onlyMaster: true,
    subLinks: [
      {
        name: "C2S",
        subLinks: [
          // { name: "Dashboard" },
          { name: "Geral", url: "/app/reports/general" },
          // { name: "Métricas de desempenho" },
          // { name: "Negócios fechados por origem" },
          // { name: "Negócios fechados por natureza da negociação" },
          // { name: "Leads" },
        ],
      },
      // {
      //   name: "Régua de relacionamento",
      // },
      // {
      //   name: "C2SBot",
      // },
    ],
  },
  {
    name: "Configurações",
    onlyMaster: true,
    subLinks: [
      { name: "Usuários", url: "/app/users" },
      { name: "Integrações", url: "/app/credentials" },
      // { name: "Portais" },
      // { name: "Alertas" },
      { name: "Regras de distribuição", url: "/app/rules" },
      { name: "Etiquetas", url: "/app/tags" },
    ],
  },
];
